import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import { Option } from 'carbon-react/lib/components/select';
import SimpleSelect from 'carbon-react/lib/components/select/simple-select';

import { Consolidation } from '@futrli-sdk/consolidations';

interface PresentationCurrencyFilterProps {
  onChange: (value: string) => void;
  selectedValue: string;
  consolidations?: Consolidation[];
}

export const PresentationCurrencyFilter = ({
  onChange,
  selectedValue,
  consolidations = []
}: PresentationCurrencyFilterProps) => {
  const intl = useIntl();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const options = useMemo(() => {
    const currencies = new Set<string>();

    consolidations.forEach(consolidation => {
      if (consolidation.display_currency) {
        currencies.add(consolidation.display_currency);
      }
    });

    const sortedCurrencies = Array.from(currencies)
      .map(currency => ({ value: currency, label: currency }))
      .sort((a, b) => a.label.localeCompare(b.label));

    return [
      {
        value: 'all',
        label: intl.formatMessage({
          id: 'predict.filters.presentation_currency.all',
          defaultMessage: 'All currencies'
        })
      },
      ...sortedCurrencies
    ];
  }, [consolidations, intl]);

  return (
    <Box width={250}>
      <SimpleSelect
        label={intl.formatMessage({
          id: 'consolidation.presentation_currency',
          defaultMessage: 'Presentation currency'
        })}
        value={selectedValue}
        onChange={handleChange}
      >
        {options.map(option => (
          <Option key={option.value} value={option.value} text={option.label}>
            {option.label}
          </Option>
        ))}
      </SimpleSelect>
    </Box>
  );
};
